import React from 'react';
import { Section } from '../ui/Section';
import { Check, X } from 'lucide-react';
export function ParaQuien() {
  return <Section background="off-white" data-id="element-182">
      <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-stone-900" data-id="element-183">
        ¿Es para vos?
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-184">
        <div className="bg-white p-8 rounded-2xl shadow-sm border-t-4 border-emerald-500" data-id="element-185">
          <h3 className="text-xl font-bold mb-6 text-stone-900" data-id="element-186">
            ES PARA VOS SI:
          </h3>
          <ul className="space-y-4" data-id="element-187">
            {['Querés comer más ordenada sin vivir midiendo todo', 'Querés bajar la ansiedad de "¿qué como?"', 'Querés algo que funcione incluso cuando estás cansada', 'Estás cuidando lo que comés por salud, digestión o simplemente querés más orden'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-188">
                <div className="bg-emerald-100 p-1 rounded-full mt-0.5" data-id="element-189">
                  <Check className="w-4 h-4 text-emerald-700" data-id="element-190" />
                </div>
                <span className="text-stone-700" data-id="element-191">{item}</span>
              </li>)}
          </ul>
        </div>

        <div className="bg-white p-8 rounded-2xl shadow-sm border-t-4 border-stone-300" data-id="element-192">
          <h3 className="text-xl font-bold mb-6 text-stone-900" data-id="element-193">
            NO ES PARA VOS SI:
          </h3>
          <ul className="space-y-4" data-id="element-194">
            {['Buscás promesas clínicas o "curas"', 'Querés un plan médico personalizado', 'No querés cocinar nada nunca'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-195">
                <div className="bg-stone-100 p-1 rounded-full mt-0.5" data-id="element-196">
                  <X className="w-4 h-4 text-stone-500" data-id="element-197" />
                </div>
                <span className="text-stone-500" data-id="element-198">{item}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </Section>;
}